import dayjs from 'dayjs';

const TEMPLATE = '#YYMMDD/HHmmss';
export const formatTimestampToCustomId = (isoString?: string | null): string => {
    if (!isoString) return '-';
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return '-';

    return dayjs(isoString).format(TEMPLATE);
};
